import * as React from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
  Checkbox,
  OutlinedInput
} from '@material-ui/core';
import { useGroupContext } from 'pages/Unitlookup/stores/Group/GroupProvider';
import { useAccessibilityContext } from 'pages/Unitlookup/stores/AccessibilityProvider/AccessibilityProvider';

export const Groups: React.FC = () => {
  const { groups, hasMoreGroups, totalGroups, onGroupSelected } = useGroupContext();
  const { accessibility } = useAccessibilityContext();

  const isReadonly = accessibility?.groups.readonly || hasMoreGroups;

  const helperText = hasMoreGroups
    ? `Too many groups (${totalGroups}). Use Manager to edit groups.`
    : undefined;

  return (
    <FormControl variant="outlined" fullWidth margin="normal" disabled={isReadonly}>
      <InputLabel htmlFor="select-groups">Groups</InputLabel>
      <Select
        multiple
        value={groups.filter(group => group.selected).map(group => group.name)}
        input={<OutlinedInput labelWidth={52} id="select-groups" />}
        renderValue={selected =>
          selected instanceof Array ? selected.join(', ') : ''
        }
        disabled={isReadonly}
      >
        {groups.map(group => (
          <MenuItem key={group.id} value={group.id}>
            <Checkbox
              checked={group.selected}
              onChange={evt =>
                onGroupSelected(group.id, evt.currentTarget.checked)
              }
            />
            <ListItemText primary={group.name} />
          </MenuItem>
        ))}
      </Select>
      {helperText && (
        <FormHelperText>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};
